export default "__VITE_ASSET__CJmvJos7__"